import SearchDropdown from "../../../../components/UI/PageInput/SearchDropdown";
import CustomInput from "../../../../components/UI/PageInput/CustomInput";
import { numberValidation } from "../../../../validations/formValidations";

const BankInfo = ({
  userSetup,
  register,
  errors,
  setValue,
  control,
  watch,
}) => {
  const bank_name_id = watch("bank_name_id");
  return (
    <div className="pl-1">
      <div className="userInfoWrap">
        <h4 className="userInfoHeading">Bank Info</h4>
        <div className="flex gap-3 p-4">
          <div className="w-full">
            <SearchDropdown
              name="bank_name_id"
              label="Bank Name *"
              keyName="name"
              id="id"
              options={userSetup.banks}
              control={control}
              selectedVal={bank_name_id}
              setValue={setValue}
              error={errors.bank_name_id}
              search={true}
            />
            <CustomInput
              type="text"
              name="ifsc"
              labelText="IFSC Code *"
              placeholder="Enter"
              register={{
                ...register("ifsc", {
                  required: "Please Enter your IFSC Code",
                }),
              }}
              error={errors.ifsc}
            />
          </div>
          <div className="w-full">
            <CustomInput
              type="text"
              name="account_number"
              labelText="Bank Account No. *"
              placeholder="Enter"
              register={{
                ...register("account_number", {
                  ...numberValidation,
                  required: "Please Enter your Account number",
                }),
              }}
              error={errors.account_number}
            />
            <CustomInput
              type="text"
              name="bank_branch"
              labelText="Bank Branch *"
              placeholder="Enter"
              register={{
                ...register("bank_branch", {
                  required: "Please Enter your Branch Name ",
                }),
              }}
              error={errors.bank_branch}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default BankInfo;
